import { createCommand } from '../createCommand/createCommand';
import {
  CommandBase,
  CommandDefinitionBase,
  CommandGroup,
} from '../types/command.types';

/**
 * Creates a list of command definitions.
 *
 * @param commands The commands to create.
 * @remark This function should not be used at runtime as what it produces is
 * required to be static.
 */
export function createCommands<
  TGroup extends CommandGroup,
  TName extends string,
  TCommand extends CommandBase<TName, TGroup>,
  TCommandDefinition extends CommandDefinitionBase<TCommand>,
>(commands: readonly TCommand[]): readonly TCommandDefinition[] {
  return commands.map((command) =>
    createCommand(command),
  ) as readonly TCommandDefinition[];
}
